/* eslint-disable eqeqeq */
import {
  faArrowUpRightFromSquare,
  // faEdit,
  // faTrash,
  faDownload,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DeleteDocumentModal from "./DeleteDocumentModal";

import React, { useCallback, useState } from "react";
import CustomTooltip from "../../../../common/CustomTooltip";
import { API, defaultLimitPagination, get } from "../../../../../config";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import DocumentVariations from "./DocumentVariations";
import { formatNumber, formatSubcontractorName } from "../../../../common/Misc";
import { defaultBaseUrl } from "../../../../../APIConfig/Interceptor";
// import { useParams } from "react-router-dom";

const DocumentListActionButton = ({
  id,
  handleDownload,
  handleView,
  handleDelete,
  type,
  document,
}) => {
  const [showDelete, setShowDelete] = useState(false);
  const params = useParams();
  const projectId = params?.project_id;

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [showVariation, setShowVariation] = useState(false);
  const [variationData, setVariationData] = useState([]);

  const variationColumns = [
    {
      dataField: "date",
      text: "Date",
      style: {
        width: "100px",
      },
    },
    {
      dataField: "name",
      text: "Name",
      style: {
        width: "100px",
      },
    },
    {
      dataField: "contractor_name",
      text: "Subcontractor Name",
      style: {
        width: "15%",
      },
    },
    {
      dataField: "contract_number",
      text: "Contract / Agreement Number",
      style: {
        width: "12%",
      },
    },
    {
      dataField: "variation_amount",
      text: "Variation Value",
      style: {
        width: "12%",
      },
    },
    {
      dataField: "contract_value_exc",
      text: "Contract Value (Ex. GST)",
      style: {
        width: "12%",
      },
    },
    {
      dataField: "contract_value",
      text: "Contract Value (Inc. GST)",
      style: {
        width: "12%",
      },
    },
    {
      dataField: "document_file_name",
      text: "Document File / URL",
    },
  ];

  const fetchDocumentVariationData = useCallback(
    async (id, passLimit, passPage) => {
      if (id) {
        try {
          setLoading(true);
          const { data } = await get(
            `${
              API.GET_DOCUMENT_LIST
            }/${id}?builder_project_id=${projectId}&limit=${
              passLimit ? passLimit : limit ? limit : defaultLimitPagination
            }&page=${passPage ? passPage : page ? page : 1}
            `
          );
          setLimit(data?.data?.per_page);
          setPage(data?.data?.current_page);
          setTotal(data?.data?.total);
          setFrom(data?.data?.from);
          setTo(data?.data?.to);
          setVariationData(data?.data?.data);
          setLoading(false);
        } catch (error) {
          if (error?.response?.data?.errors) {
            setLoading(false);
            Object.keys(error?.response?.data?.errors).forEach((key) => {
              toast.error(error?.response?.data?.errors[key][0]);
            });
          } else {
            setLoading(false);
            toast.error(error?.message);
          }
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [projectId]
  );

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchDocumentVariationData(id, limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchDocumentVariationData(id, limit, page);
  };

  const toggleCloseModal = () => {
    setShowVariation(!showVariation);
  };

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };

  const defaultOption = [
    { label: "Copy Of Contracts", value: 1, tabKey: "copy-of-contracts" },
    {
      label: "Any Contract Variation/Amendment Documents",
      value: 2,
      tabKey: "variations-contracts",
    },
    {
      label: "Payment Claims/ Schedules Given And Received",
      value: 3,
      tabKey: "payment-claims-and-schedules",
    },
    { label: "Supporting Documents", value: 4, tabKey: "supporting-documents" },
    { label: "Other Docs", value: 5, tabKey: "others" },
  ];

  const varationDataGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: variationData[i]?.id,
        date: variationData[i]?.created_at
          ? variationData[i]?.created_at?.split(" ")?.[0]
          : "-",
        name:
          variationData[i]?.count === 0
            ? "Original"
            : variationData[i]?.count
            ? `Variation ${variationData[i]?.count}`
            : "-",
        contractor_name: variationData[i]?.contact
          ? formatSubcontractorName(variationData[i]?.contact)
          : "-",
        contract_number: variationData[i]?.contract_number
          ? variationData[i]?.contract_number
          : "-",
        variation_amount: variationData[i]?.amount ? (
          <span
            className={
              variationData[i]?.transaction_type ? "rag-green" : "rag-red"
            }
          >
            {`$${formatNumber(Number(variationData[i]?.amount))}
                    `}
          </span>
        ) : (
          "$0.00"
        ),
        contract_value_exc: variationData[i]?.contract_value_exc
          ? `$${formatNumber(Number(variationData[i]?.contract_value_exc))}`
          : "-",
        contract_value: variationData[i]?.contract_value
          ? `$${formatNumber(Number(variationData[i]?.contract_value))}`
          : "-",
        // pta_closing_balance: variationData[i]?.closing_balance_pta
        //   ? formatNumber(Number(variationData[i]?.closing_balance_pta))
        //   : "-",
        document_number: variationData[i]?.document?.document_number
          ? variationData[i]?.document?.document_number
          : "-",
        document_file_name: variationData[i]?.document?.document ? (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              window.open(variationData[i]?.document?.document, "_blank");
            }}
            title={variationData[i]?.document?.document}
          >
            {variationData[i]?.document?.document?.includes(
              defaultBaseUrl()
            ) ? (
              variationData[i]?.document?.document?.split("/")?.slice(-1)
            ) : (
              <span>
                Open Link <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </span>
            )}
          </div>
        ) : (
          "-"
        ),
        document: variationData[i]?.document?.document,
        document_type: variationData[i]?.document?.document_type
          ? defaultOption?.find(
              (item) => item?.value == variationData[i]?.document?.document_type
            )?.label
          : "-",
      });
    }
    return items;
  };
  const variationDatas = varationDataGenerator(variationData?.length);

  return (
    <>
      <span>
        {type?.value === 1 && (
          <>
            <CustomTooltip message={"Variations"}>
              <span>
                <FontAwesomeIcon
                  icon={faEye}
                  size="1x"
                  onClick={() => toggleCloseModal()}
                  data-toggle="modal"
                  data-target="#account"
                />
              </span>
            </CustomTooltip>
            {document && (
              <>
                <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
              </>
            )}
          </>
        )}
        {document && (
          <CustomTooltip message={"Download"}>
            <span>
              <FontAwesomeIcon
                onClick={() => handleDownload()}
                icon={faDownload}
                size="1x"
                data-toggle="modal"
                data-target="#deleteAccount"
              />
            </span>
          </CustomTooltip>
        )}
      </span>

      {/* {handleDelete ? (
        <>
          &nbsp;&nbsp;/&nbsp;&nbsp;
          <span>
            <CustomTooltip message={"Delete"}>
              <span>
                <FontAwesomeIcon
                  onClick={toggleDeleteModal}
                  icon={faTrash}
                  size="1x"
                  data-toggle="modal"
                  data-target="#deleteAccount"
                />
              </span>
            </CustomTooltip>
          </span>
        </>
      ) : (
        ""
      )} */}
      {showDelete && (
        <DeleteDocumentModal
          DocumentID={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={handleDelete}
          showDelete={showDelete}
        />
      )}
      {/* {showAccount && (
        <EditContractorTypes
          fetchContractorTypes={fetchContractorTypes}
          ContractorTypeId={id}
          toggleContractorTypeModal={toggleContractorTypeModal}
          showAccount={showAccount}
        />
      )} */}
      {showVariation && (
        <DocumentVariations
          showVariation={showVariation}
          toggleCloseModal={toggleCloseModal}
          variationColumns={variationColumns}
          variationData={variationDatas}
          loading={loading}
          total={total}
          limit={limit}
          page={page}
          handleUpdateLimit={handleUpdateLimit}
          handleChangePage={handleChangePage}
          from={from}
          to={to}
          fetchDocumentVariationData={fetchDocumentVariationData}
          id={id}
        />
      )}
    </>
  );
};

export default DocumentListActionButton;
